import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const notifications = [
  { emoji: '🎬', name: 'Sarah K.', location: 'Austin', action: 'just published her first video', time: '2 min ago' },
  { emoji: '📈', name: 'Marcus R.', location: 'London', action: 'grew his channel 40% this month', time: '5 min ago' },
  { emoji: '🎤', name: 'Priya M.', location: 'Toronto', action: 'converted 12 blog posts today', time: '9 min ago' },
  { emoji: '🚀', name: 'Jake L.', location: 'NYC', action: 'signed up for free', time: '11 min ago' },
  { emoji: '⭐', name: 'Elena V.', location: 'Berlin', action: 'left a 5-star review', time: '14 min ago' },
  { emoji: '🎬', name: 'Chris T.', location: 'Sydney', action: 'published 3 videos in one hour', time: '18 min ago' },
  { emoji: '📈', name: 'Aisha B.', location: 'Dubai', action: 'got 10K views on her first video', time: '22 min ago' },
  { emoji: '🔥', name: 'David M.', location: 'Singapore', action: 'upgraded to Creator Pro', time: '25 min ago' },
  { emoji: '✨', name: 'Lisa W.', location: 'Tokyo', action: 'created her 50th video', time: '28 min ago' },
];

const LiveActivityTicker = () => {
  const [currentNotification, setCurrentNotification] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const showNotification = () => {
      const randomIndex = Math.floor(Math.random() * notifications.length);
      setCurrentNotification(notifications[randomIndex]);
      setIsVisible(true);

      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };

    // Initial delay
    const initialDelay = setTimeout(() => {
      showNotification();
    }, 3000);

    // Show notifications every 8-15 seconds
    const interval = setInterval(() => {
      showNotification();
    }, Math.random() * 7000 + 8000);

    return () => {
      clearTimeout(initialDelay);
      clearInterval(interval);
    };
  }, []);

  return (
    <AnimatePresence>
      {isVisible && currentNotification && (
        <motion.div
          initial={{ opacity: 0, y: 100, x: 0 }}
          animate={{ opacity: 1, y: 0, x: 0 }}
          exit={{ opacity: 0, y: 100 }}
          transition={{ type: 'spring', damping: 25, stiffness: 300 }}
          className="fixed bottom-24 left-6 z-50 glass-strong rounded-xl p-4 max-w-sm shadow-2xl border border-white/10"
          data-testid="live-activity-ticker"
        >
          <div className="flex items-start gap-3">
            <span className="text-2xl">{currentNotification.emoji}</span>
            <div className="flex-1 min-w-0">
              <p className="text-sm text-white">
                <span className="font-semibold">{currentNotification.name}</span>
                <span className="text-gray-400"> from {currentNotification.location}</span>
                <span className="text-gray-300"> {currentNotification.action}</span>
              </p>
              <div className="flex items-center gap-2 mt-1">
                <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></span>
                <span className="text-xs text-gray-500">{currentNotification.time}</span>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default LiveActivityTicker;
